import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import CheckoutActions from 'app/actions/CheckoutActions';
import { currentAccountSelector } from 'app/selectors/AuthSelector';

const PrintCheckedOutContainer = loadable(() => import('app/containers/print/PrintCheckedOutContainer'));

export function PrintCheckedOutPageRoute() {
  return <PrintCheckedOutContainer />;
}

function getRouteData({ dispatch, state, params, query }) {
  const account = currentAccountSelector(state);
  const accountId = account && account.get('id');
  if (!accountId) return [];

  return [dispatch(CheckoutActions.fetchCheckouts({ accountId, ...params, ...query }))];
}

export default connectRoute(PrintCheckedOutPageRoute, { getRouteData });
